function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";
import { html as c } from "../../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";
import "../../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";
import { customElement as p } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/custom-element.js";
import { property as d } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/property.js";
import { state as v } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/state.js";
import "../tab/tab.gator.js";
import { KEY_CONSTANTS as b } from "../../../../consts/key-constants.js";
import { createRef as f, ref as u } from "../../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/directives/ref.js";
import { TestableLitElement as m } from "../../../../utils/components/testable-lit-element/testable-lit-element.js";
import T from "../../../../packages/web-components/src/components/tabs/gator/tabs.gator.scss.js";
import g from "../../../../packages/web-components/src/components/tabs/gator/tabs.gator.tokens.scss.js";
import y from "../../../../packages/web-components/src/tokens/semantic.tokens.scss.js";
import $ from "../../../../packages/web-components/src/tokens/primitive.tokens.scss.js";
import { ifDefined as I } from "../../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/directives/if-defined.js";
import { unsafeCSS as l } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/css-tag.js";
var x = Object.defineProperty,
  S = Object.getOwnPropertyDescriptor,
  r = function r(t, e, a, o) {
    for (var s = o > 1 ? void 0 : o ? S(e, a) : e, n = t.length - 1, h; n >= 0; n--) (h = t[n]) && (s = (o ? h(e, a, s) : h(s)) || s);
    return o && s && x(e, a, s), s;
  };
var i = /*#__PURE__*/function (_m) {
  function i() {
    var _this;
    _classCallCheck(this, i);
    _this = _callSuper(this, i, arguments), _this.tabsetAriaLabelledByElements = [], _this.tabsetAriaLabel = void 0, _this.size = "medium", _this.activeTabIndex = 0, _this._contentRef = f(), _this._tablistRef = f();
    return _this;
  }
  _inherits(i, _m);
  return _createClass(i, [{
    key: "updated",
    value: function updated(t) {
      _superPropGet(i, "updated", this, 3)([t]), t.has("tabsetAriaLabelledByElements") && (this._tablistRef.value.ariaLabelledByElements = this.tabsetAriaLabelledByElements);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return this.tabs || (this.tabs = Array.from(this.querySelectorAll("ngc-tab"))), c(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            <div class=\"gator-tabset\">\n                <div ", " role=\"tablist\" class=\"gator-tabset-header\" aria-label=", ">\n                    ", "\n                </div>\n                ", "\n                <div ", "\n                     aria-labelledby=\"gator-tab-", "\"\n                     class=\"gator-tabset-content\"\n                     id=\"gator-tabpanel-", "\"\n                     tabindex=\"0\"\n                     role=\"tabpanel\"\n                >\n                    ", "\n                </div>\n            </div>\n        "])), u(this._tablistRef), I(this.tabsetAriaLabel), this.tabs.map(function (t, e) {
        return c(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n                        <div class=\"", " gator-tab\"\n                             id=\"gator-tab-", "\"\n                             role=\"tab\"\n                             tabindex=\"", "\"\n                             @keydown=\"", "\"\n                             @click=\"", "\"\n                             aria-controls=\"gator-tabpanel-", "\"\n                             aria-selected=\"", "\"\n                        >\n                            <div class=\"gator-tab-container ", " ", "\">\n                                <div class=\"gator-tab-button ", "  ", "\">\n                                    <span class=\"gator-tab-button-name\">\n                                        ", "\n                                    </span>\n                                </div>\n                            </div>\n                        </div>\n                    "])), _this2.tabSpacerClass, e + 1, _this2.getButtonTabIndex(e), function (a) {
          return _this2.handleTabKeydown(a);
        }, function () {
          return _this2.activeTabIndex = e;
        }, e + 1, e === _this2.activeTabIndex, e === _this2.activeTabIndex ? " gator-tab-container_active" : "", _this2.tabContainerSizeClass, e === _this2.activeTabIndex ? " gator-tab-button_active" : "", _this2.tabSizeClass, t.getAttribute("name"));
      }), this.size === "large" ? c(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<div class=\"gator-tab-border\"></div>"]))) : null, u(this._contentRef), this.activeTabIndex + 1, this.activeTabIndex + 1, this.tabs[this.activeTabIndex]);
    }
  }, {
    key: "tabSizeClass",
    get: function get() {
      return this.size ? "gator-tab-button-".concat(this.size) : "";
    }
  }, {
    key: "tabContainerSizeClass",
    get: function get() {
      return this.size ? "gator-tab-container-".concat(this.size) : "";
    }
  }, {
    key: "tabSpacerClass",
    get: function get() {
      return this.size != "large" ? "" : "gator-tabset-spacer";
    }
  }, {
    key: "getButtonTabIndex",
    value: function getButtonTabIndex(t) {
      return t === this.activeTabIndex ? "0" : "-1";
    }
  }, {
    key: "handleTabKeydown",
    value: function handleTabKeydown(t) {
      var a;
      if (!this.tabs) return;
      var e = (a = this.shadowRoot) == null ? void 0 : a.querySelectorAll(".gator-tabset-header [role=tab]");
      if (t.key === b.RIGHT) {
        if (this.activeTabIndex === this.tabs.length - 1) {
          this.focusFirstTab(), t.preventDefault();
          return;
        }
        this.activeTabIndex++, e[this.activeTabIndex].focus();
      } else if (t.key === b.LEFT) {
        if (this.activeTabIndex === 0) {
          this.focusLastTab(), t.preventDefault();
          return;
        }
        this.activeTabIndex--, e[this.activeTabIndex].focus(), t.preventDefault();
      } else t.key === b.HOME ? (this.focusFirstTab(), t.preventDefault()) : t.key === b.END && (this.focusLastTab(), t.preventDefault());
    }
  }, {
    key: "focusFirstTab",
    value: function focusFirstTab() {
      var e;
      var t = (e = this.shadowRoot) == null ? void 0 : e.querySelectorAll(".gator-tabset-header [role=tab]");
      this.activeTabIndex = 0, t[this.activeTabIndex].focus();
    }
  }, {
    key: "focusLastTab",
    value: function focusLastTab() {
      var e;
      if (!this.tabs) return;
      var t = (e = this.shadowRoot) == null ? void 0 : e.querySelectorAll(".gator-tabset-header [role=tab]");
      this.activeTabIndex = this.tabs.length - 1, t[this.activeTabIndex].focus();
    }
  }]);
}(m);
i.styles = [l(T), l(g), l(y), l($)];
r([d({
  type: String,
  attribute: "tabset-aria-labelled-by-elements"
})], i.prototype, "tabsetAriaLabelledByElements", 2);
r([d({
  type: String,
  attribute: "tabset-aria-label"
})], i.prototype, "tabsetAriaLabel", 2);
r([d({
  type: String
})], i.prototype, "size", 2);
r([v()], i.prototype, "activeTabIndex", 2);
i = r([p("ngc-tabset")], i);
export { i as NgcTabset };